"use strict";
exports.__esModule = true;
exports.InlineSpacing = exports.StackSpacing = exports.InsetStretchSpacing = exports.InsetSquishSpacing = exports.InsetSpacing = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        stackSpacing: {
            alignItems: function (_a) {
                var alignItems = _a.alignItems;
                return alignItems;
            },
            display: 'flex',
            flexDirection: 'column',
            '& > * + *': {
                margin: function (_a) {
                    var scale = _a.scale;
                    return theme.spacing(scale) + "px 0 0 !important";
                }
            }
        },
        inlineSpacing: {
            display: 'flex',
            alignItems: function (_a) {
                var alignItems = _a.alignItems;
                return alignItems;
            },
            '& > * + *': {
                margin: function (_a) {
                    var scale = _a.scale;
                    return "0 0 0 " + theme.spacing(scale) + "px !important";
                }
            }
        }
    });
});
function InsetSpacing(props) {
    var children = props.children, scale = props.scale;
    var theme = core_1.useTheme();
    return react_1["default"].createElement("div", { style: { padding: theme.spacing(scale) } }, children);
}
exports.InsetSpacing = InsetSpacing;
function InsetSquishSpacing(props) {
    var children = props.children, scale = props.scale;
    var theme = core_1.useTheme();
    return (react_1["default"].createElement("div", { style: {
            padding: theme.spacing(scale / 2) + "px " + theme.spacing(scale) + "px"
        } }, children));
}
exports.InsetSquishSpacing = InsetSquishSpacing;
function InsetStretchSpacing(props) {
    var children = props.children, scale = props.scale;
    var theme = core_1.useTheme();
    return (react_1["default"].createElement("div", { style: {
            padding: theme.spacing(scale * 1.5) + "px " + theme.spacing(scale) + "px"
        } }, children));
}
exports.InsetStretchSpacing = InsetStretchSpacing;
function StackSpacing(props) {
    var _a = props.alignItems, alignItems = _a === void 0 ? 'flex-start' : _a, children = props.children, scale = props.scale;
    var classes = useStyles({ alignItems: alignItems, scale: scale });
    return react_1["default"].createElement("div", { className: classes.stackSpacing }, children);
}
exports.StackSpacing = StackSpacing;
function InlineSpacing(props) {
    var _a = props.alignItems, alignItems = _a === void 0 ? 'flex-start' : _a, children = props.children, scale = props.scale;
    var classes = useStyles({ alignItems: alignItems, scale: scale });
    return react_1["default"].createElement("div", { className: classes.inlineSpacing }, children);
}
exports.InlineSpacing = InlineSpacing;
//# sourceMappingURL=Spacing.js.map